import { useState } from 'react'

const usePageAlert = () => {
  const defaultState =
    typeof window !== 'undefined'
      ? !!sessionStorage.getItem('hidePageAlert')
      : false

  const [isHiddenPageAlert, setAlertStatus] = useState(defaultState)

  const closeAlert = () => {
    setAlertStatus(true)
    sessionStorage.setItem('hidePageAlert', 'true')
  }

  return [isHiddenPageAlert, closeAlert]
}

export default usePageAlert
